import { FileTypeService } from 'src/app/shared/services/file-type.service';

import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

import { DocumentInfo } from '../../models/DocumentInfo';
import { DocumentService } from '../../service/document.service';

@Component({
  selector: 'app-show-document-content',
  templateUrl: './show-document-content.component.html',
  styleUrls: ['./show-document-content.component.scss']
})
export class ShowDocumentContentComponent  implements OnInit, OnChanges {

  content: any;
  isImage: boolean;
  isText: boolean;
  isPdf: boolean;
  isUnknown: boolean;
  contentType: string;
  downloadUrl: string;
  
  constructor(private documentService: DocumentService,
    private fileTypeService: FileTypeService) {
      
    }
    @Input() dialog: DialogRef;
    @Input() documentInfo: DocumentInfo;
    @Input() documentContent: Blob;
    @Input() fileExtension: string;
    @Input() fileName: string;
    @Input() zoomMode: boolean;

  ngOnInit(): void {
    if (this.documentInfo?.id) {
      this.fileExtension = this.documentInfo.fileExtension;
      this.fileName = this.documentInfo.name;
      //download content from db if document id provided
      this.documentService.downloadDocument(this.documentInfo.id).subscribe((res) => {
        this.setDocumentData(res);
      });
    }
    else{
      if(!this.documentContent){
        console.error('When no id provided then content is mandatory!');
        return;
      }
      this.setDocumentData(this.documentContent);
    }

  }

  setDocumentData(content: Blob) {
    this.contentType = content.type;

    this.isImage = this.fileTypeService.isFileImage(this.fileExtension);
    if (this.isImage) {
      const reader = new FileReader();
      reader.onload = (e) => { this.content = e.target.result; }
      reader.readAsDataURL(content);
      return;
    }


    this.isText = content.type.startsWith("text") || this.fileExtension ==".sms";
    if (this.isText) {
      const reader = new FileReader();
      reader.onload = (e) => { this.content = e.target.result; }
      reader.readAsText(content);
      return;
    }


    this.isPdf = (content.type.endsWith("pdf"));
    if (this.isPdf) {
 
      this.content = content;
      const blob = new Blob([this.content], { type: this.contentType });
      this.downloadUrl = window.URL.createObjectURL(blob);
      return;
    }

    this.isUnknown = true;
    this.content = content;

    if (this.dialog) {
      this.dialog.dialog.instance.minHeight = '20vh';
      this.dialog.dialog.instance.minWidth = '20vw';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ngOnInit();
  }

  downloadFile() {

    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob([this.content], { type: this.contentType }));
    downloadLink.setAttribute('download', this.fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.parentNode.removeChild(downloadLink);
    if(this.dialog){
      this.dialog.close();
    }
  }
}



